<!-- MODAL destinoDeposito -->
<div mdbModal #destinoDeposito="mdb-modal" class="modal fade" id="basicExample" tabindex="-1" role="dialog"
    aria-labelledby="myModalLabel" aria-hidden="true" [config]="{ backdrop: true, ignoreBackdropClick: true }">
    <div class="modal-dialog modal-fluid" style="max-width: 70%;" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h4 class="modal-title w-100 text-left" id="myModalLabel">
                    Destino del Depósito
                </h4>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close"
                    (click)="destinoDeposito.hide()">
                    <span aria-hidden="true">×</span>
                </button>
            </div>
            <div class="modal-body">
                <form autocomplete="off" [formGroup]="formHeader">
                    <div class="row">
                        <div class="col" style="max-width: 200px;">
                            <div class="md-form">
                                <input placeholder="RUT" class="form-control" [ngClass]="{disabledContent: allowSave}"
                                    type="text" value="" maxLength="10" required #rutDepositante formControlName="rut"
                                    formatRut />
                                <label for="rutDepositante">RUT</label>
                                <div *ngIf="
                                    formHeader.get('rut').invalid &&
                                    (formHeader.get('rut').dirty ||
                                    formHeader.get('rut').touched)
                                    ">
                                    <mdb-error *ngIf="formHeader.get('rut').hasError('required')">
                                        Ingrese rut
                                    </mdb-error>
                                </div>
                            </div>
                        </div>
                        <div class="col" style="max-width: 200px;">
                            <div class="md-form">
                                <input value="" type="text" class="form-control" placeholder="Nombre del depositante"
                                    required #nombre formControlName="nombre" />
                                <label for="nombre">Nombre</label>
                                <div *ngIf="
                                    formHeader.get('nombre').invalid &&
                                    (formHeader.get('nombre').dirty ||
                                    formHeader.get('nombre').touched)
                                    ">
                                    <mdb-error *ngIf="formHeader.get('nombre').hasError('required')">
                                        Ingrese nombre
                                    </mdb-error>
                                </div>
                            </div>
                        </div>
                        <div class="col" style="max-width: 200px;">
                            <div class="md-form">
                                <mdb-select ngDefaultControl label="Banco destino" [options]="optionsBanco"
                                    placeholder="Banco destino" [filterEnabled]="true" formControlName="banco">
                                </mdb-select>
                                <div *ngIf="
                                    formHeader.get('banco').invalid &&
                                    (formHeader.get('banco').dirty ||
                                    formHeader.get('banco').touched)
                                    ">
                                    <mdb-error *ngIf="formHeader.get('banco').hasError('required')">
                                        Ingrese banco
                                    </mdb-error>
                                </div>
                            </div>
                        </div>
                        <div class="col" style="max-width: 200px;">
                            <div class="md-form">
                                <mdb-select ngDefaultControl label="Cuenta bancaria" [options]="optionsCuenta"
                                    placeholder="Cuenta bancaria" [filterEnabled]="true" formControlName="cuenta">
                                </mdb-select>
                                <div *ngIf="
                                    formHeader.get('cuenta').invalid &&
                                    (formHeader.get('cuenta').dirty ||
                                    formHeader.get('cuenta').touched)
                                    ">
                                    <mdb-error *ngIf="formHeader.get('cuenta').hasError('required')">
                                        Ingrese cuenta
                                    </mdb-error>
                                </div>
                            </div>
                        </div>
                        <div class="col " style="max-width: 200px;">
                            <div class="form-check">
                                <input type="radio" class="form-check-input" id="rbVistaCliente" mdbInput
                                    formControlName="tipoVista" [value]="RB_TIPO_VISTA_RESUMEN" />
                                <label class="form-check-label" for="rbVistaCliente">Vista Resumen</label>
                            </div>
                            <!-- Material unchecked -->
                            <div class="form-check">
                                <input type="radio" class="form-check-input" id="rbVistaProducto" mdbInput
                                    formControlName="tipoVista" [value]="RB_TIPO_VISTA_DETALLE" />
                                <label class="form-check-label" for="rbVistaProducto">Vista Detalle</label>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col" style="max-width: 200px;">
                            <div class="md-form">
                                <input value="" type="text" id="ndeposito" class="form-control"
                                    placeholder="Número de depósito" required #ndeposito formControlName="nroDeposito"
                                    onlyNumbers />
                                <div *ngIf="
                                    formHeader.get('nroDeposito').invalid &&
                                    (formHeader.get('nroDeposito').dirty ||
                                    formHeader.get('nroDeposito').touched)
                                    ">
                                    <mdb-error *ngIf="formHeader.get('nroDeposito').hasError('required')">
                                        Ingrese nro depósito
                                    </mdb-error>
                                </div>
                            </div>
                        </div>
                        <div class="col" style="max-width: 200px;">
                            <div class="md-form">
                                <mdb-date-picker [inline]="true" name="fechaDeposito" #datePickerFechaDeposito
                                    [placeholder]="'Fecha de deposito'" required formControlName="fechaDeposito"
                                    #datePickerFechaDeposito>
                                </mdb-date-picker>
                                <div *ngIf="
                                    formHeader.get('fechaDeposito').invalid &&
                                    (formHeader.get('fechaDeposito').dirty ||
                                    formHeader.get('fechaDeposito').touched)
                                    ">
                                    <mdb-error *ngIf="formHeader.get('fechaDeposito').hasError('required')">
                                        Ingrese fecha depósito
                                    </mdb-error>
                                </div>
                            </div>
                        </div>

                        <!-- <div class="col" style="max-width: 200px;">
                            <div></div>
                            <button mdbBtn type="button" color="secondary" size="sm" mdbWavesEffect
                                (click)="agregarBanco()" [ngClass]="{disabledContent: allowSave}">
                                Agregar banco
                            </button>
                        </div> -->

                    </div>
                </form>
                <div class="table-responsive" *ngIf="formHeader.get('tipoVista').value === RB_TIPO_VISTA_RESUMEN" >
                    <app-no-data-alert *ngIf="listaMovimientosResumen?.length === 0">
                    </app-no-data-alert>

                    <table class="table table-striped table-hover table-sm align-middle"
                        *ngIf="listaMovimientosResumen?.length > 0">
                        <thead class="grey lighten-2">
                            <tr>
                                <th scope="col">Banco</th>
                                <th scope="col" class="text-right">Cantidad</th>
                                <th scope="col" class="text-right">Monto</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let mov of listaMovimientosResumen">
                                <td>{{mov.banco_nombre_origen}}</td>
                                <td class="text-right">{{mov.cantidad}}</td>
                                <td class="text-right">$ {{mov.monto | numerico}}</td>
                            </tr>
                        </tbody>
                    </table>

                    <div class="table-responsive">
                        <table class="table table-striped table-hover table-sm align-middle">
                            <tbody style="text-align:right;">
                                <tr>
                                    <td class="col-8" style="font-weight: bold; font-size: 15px;">
                                        <span>Total: </span>
                                        <span>${{MontoTotalResumen | numerico}}</span>
                                    </td>
                            </tbody>
                        </table>
                    </div>

                    <app-pagination [context]="paginationContext" (onPageChange)="onPageChange($event)"
                        *ngIf="listaMovimientos?.length > 0"></app-pagination>
                </div>

                

                <div class="table-responsive" *ngIf="formHeader.get('tipoVista').value === RB_TIPO_VISTA_DETALLE">
                    <app-no-data-alert *ngIf="listaMovimientos?.length === 0"></app-no-data-alert>
                    <table class="table table-striped table-hover table-sm align-middle"
                        *ngIf="listaMovimientos?.length > 0">
                        <thead class="grey lighten-2">
                            <tr>
                                <th scope="col">Banco</th>
                                <th scope="col">Nro. Doc</th>
                                <!-- <th scope="col" class="text-right">Nro. Dep</th> -->
                                <th scope="col" class="text-right">Monto</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let mov of listaMovimientos">
                                <td>{{mov.banco_nombre_origen}}</td>
                                <td>{{mov.numero_doc}}</td>


                                <!-- <td class="text-right">{{mov.numero_deposito != 0 ? mov.numero_deposito : ''}}</td> -->
                                <td class="text-right">$ {{mov.monto | numerico}}</td>
                            </tr>
                        </tbody>
                    </table>

                    <div class="table-responsive">
                        <table class="table table-striped table-hover table-sm align-middle">
                            <tbody style="text-align:right;">
                                <tr>
                                    <td class="col-8" style="font-weight: bold; font-size: 15px;">
                                        <span>Total: </span>
                                        <span>${{MontoTotalResumen | numerico}}</span>
                                    </td>
                            </tbody>
                        </table>
                    </div>

                    <app-pagination [context]="paginationContext" (onPageChange)="onPageChange($event)"
                        *ngIf="listaMovimientos?.length > 0"></app-pagination>
                </div>

            </div>
            <div class="modal-footer justify-content-between">
                <button size="sm" type="button" class="btn btn-sm btn-default waves-light" data-dismiss="modal"
                    (click)="destinoDeposito.hide()" mdbWavesEffect>
                    Cerrar
                </button>
                <app-api-button (click2)="guardarDeposito()" [processing]="processing">Guardar</app-api-button>
            </div>
        </div>
    </div>
</div>